import React from "react";
import withStyles from "isomorphic-style-loader/lib/withStyles";
import { withRouter } from "react-router-dom";
import s from "./styles.scss";
import { FormGroup, Label, FormFeedback, Input } from "reactstrap";
import axios from "axios";

import constants from "../../../utils/constants";
import { Styled } from "../../../toolkit/decorators/Artifact";
const DISCOUNT_BASE_URL = "/api/discountCode";

interface Props {
  onValidateDiscountCode: (
    codeInfo: DescuentoValidacion | null,
    errorMessage?: string
  ) => any;
  disabled?: boolean;
  tipoCodigo: string;
  productoId: number;
  reset: boolean;
  clubId?: string;
  personaId?: number;
  value?: string;
  onValidating: (validating: boolean) => void;
}

export interface DescuentoValidacion {
  id?: number;
  tipoCodigo?: string;
  estatus?: string;
  tipoDescuento?: string;
  descuento?: number;
  codigoDescuento: string;
  vigente?: boolean;
  clasificacionProductoId?: number;
  productoId?: number;
  hasError?: boolean;
}

interface State {
  codigoDescuento: string;
  isValid: boolean | null;
  errorMessage: string;
  isValidating: boolean;
}

@Styled(s)
export default class DiscountCodeInput extends React.Component<Props, State> {
  state = {
    codigoDescuento: "",
    isValid: null,
    errorMessage: "",
    isValidating: false
  };

  onChangeCoupon = (value: string): void => {
    this.setState({
      codigoDescuento: value,
      isValid: null,
      errorMessage: ""
    });
    if (!value) {
      this.props.onValidateDiscountCode(null);
    }
  };

  processResponse = (infoCodigo: DescuentoValidacion): boolean => {
    const { vigente: isValid } = infoCodigo;
    this.setState({
      isValid: isValid,
      errorMessage: isValid ? "" : "Código no vigente",
      isValidating: false
    });

    this.props.onValidateDiscountCode(
      isValid
        ? infoCodigo
        : {
            hasError: true,
            codigoDescuento: infoCodigo.codigoDescuento
          },
      isValid ? "" : "Código no vigente"
    );

    return isValid;
  };

  validateDiscountCode = async (): Promise<void> => {
    const { codigoDescuento } = this.state;
    const { productoId, clubId, personaId } = this.props;

    this.props.onValidating && this.props.onValidating(true);

    if (!codigoDescuento || !codigoDescuento.trim()) {
      this.setState({ isValid: null, errorMessage: "", isValidating: false });
      this.props.onValidateDiscountCode(null);
      this.props.onValidating && this.props.onValidating(false);
      return;
    }

    if (!productoId || productoId <= 0) {
      this.setState({
        isValid: false,
        errorMessage: "Debe seleccionar un producto primero",
        isValidating: false
      });

      this.props.onValidateDiscountCode(
        {
          hasError: true,
          codigoDescuento
        },
        "Debe seleccionar un producto primero"
      );

      this.props.onValidating && this.props.onValidating(false);
      return;
    }

    this.setState({ isValidating: true });

    try {
      const { data } = await axios.get(
        `${constants.BASE_URL}${DISCOUNT_BASE_URL}/validate`,
        {
          withCredentials: true,
          params: {
            codigoDescuento,
            productoId: productoId || -1,
            clubId,
            personaId
          }
        }
      );

      if (data) {
        this.processResponse(data);
        this.props.onValidating && this.props.onValidating(false);
        return;
      }

      this.props.onValidating && this.props.onValidating(false);
    } catch (err) {
      let errorMsg = "Código inválido";

      if (err.response && err.response.data && err.response.data.message) {
        errorMsg = err.response.data.message;
      }

      this.setState({
        isValid: false,
        errorMessage: errorMsg,
        isValidating: false
      });

      this.props.onValidateDiscountCode(
        {
          hasError: true,
          codigoDescuento
        },
        errorMsg
      );

      this.props.onValidating && this.props.onValidating(false);
    }
  };

  handleBlur = (): void => {
    this.validateDiscountCode();
  };

  componentWillReceiveProps(nextProps: Props) {
    if (this.props.reset !== nextProps.reset) {
      this.reset();
    }

    if (
      this.props.productoId !== nextProps.productoId &&
      this.state.codigoDescuento
    ) {
      setTimeout(() => this.validateDiscountCode(), 100);
    }
  }

  shouldComponentUpdate(nextProps: Props, nextState: State) {
    return (
      this.props.reset !== nextProps.reset ||
      this.props.productoId !== nextProps.productoId ||
      this.props.disabled !== nextProps.disabled ||
      this.state.codigoDescuento !== nextState.codigoDescuento ||
      this.state.isValid !== nextState.isValid ||
      this.state.errorMessage !== nextState.errorMessage ||
      this.state.isValidating !== nextState.isValidating
    );
  }

  reset = async () => {
    await this.setState({
      codigoDescuento: "",
      isValid: null,
      errorMessage: "",
      isValidating: false
    });
    this.props.onValidateDiscountCode(null);
  };

  public validate = async (): Promise<boolean> => {
    await this.validateDiscountCode();
    return this.state.isValid === true;
  };

  render() {
    const { disabled, productoId } = this.props;
    const { codigoDescuento, isValid, errorMessage, isValidating } = this.state;

    return (
      <FormGroup className="mb-1">
        <Label for="idCuponLocker">Cupón de descuento</Label>
        <Input
          id="idCuponLocker"
          placeholder="Ingresa el código de descuento"
          onChange={e => this.onChangeCoupon(e.target.value)}
          onBlur={this.handleBlur}
          disabled={!!disabled || !productoId || isValidating}
          value={codigoDescuento}
          valid={isValid === true}
          invalid={isValid === false}
          className={s.input}
        />
        {isValid === true && <FormFeedback valid>Código válido</FormFeedback>}
        {isValid === false && (
          <FormFeedback invalid>
            {errorMessage || "Código inválido"}
          </FormFeedback>
        )}
      </FormGroup>
    );
  }
}
